import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const FinalCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="py-24 bg-gradient-hero">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-foreground">
            Prêt à simplifier vos réservations ?
          </h2>
          
          <p className="text-xl text-muted-foreground">
            Créez votre compte en 2 minutes. Configuration guidée, 1 mois gratuit, sans engagement.
          </p>
          
          <div className="flex justify-center">
            <Button 
              size="lg" 
              className="text-base sm:text-lg min-h-[48px] sm:min-h-[52px]"
              onClick={() => navigate("/signup")}
            >
              Essayer gratuitement
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
